import { StudioVisualizationType } from '@blockworks/platform/api/research/studio';

import { VisualizationPageProps } from './get-visualization-props';

const getVisualizationDisplayName = (visualization: VisualizationPageProps['visualization']) => {
    switch (visualization.type) {
        case StudioVisualizationType.Timeseries:
        case StudioVisualizationType.Pie:
        case StudioVisualizationType.Sankey: {
            return 'Chart';
        }
        case StudioVisualizationType.Table: {
            return 'Table';
        }
        case StudioVisualizationType.Counter: {
            return 'Metric';
        }
        default:
            return undefined;
    }
};

export { getVisualizationDisplayName };
